// @flow
import * as React from "react";

import type { EyeType } from "../types/UserFormType";
import { ColorSchema } from "../../global/types/scss";
import ImagusFacePicker from "ImagusFacePicker";
import UploadFormButton from "./UploadFormButton";
import LivenessCheck from "./LivenessCheck";
import Typography from "@material-ui/core/Typography";

type EnrolFormStatesType = {
  eyes: Array<EyeType> | null,
  selected: number,
};

type EnrolFormPropsType = {
  formSubmitHandler: Function,
  setImageError: Function,
  cancelUpload: Function,
  img: string,
  faces: { [key: string]: * },
};

class EnrolForm extends React.Component<
  EnrolFormPropsType,
  EnrolFormStatesType
> {
  constructor(props: EnrolFormPropsType) {
    super(props);
    this.state = {
      eyes: null,
      selected: 0,
    };
  }

  componentDidMount() {
    if (this.props.faces) {
      let eyes = this.props.faces.map((face: *): EyeType => face.eyes);
      this.setState({ eyes: eyes, selected: 0 });
    }
  }

  updateFaces = (faces: Array<EyeType>, selection: number) => {
    this.setState({ eyes: faces, selected: selection });
  };

  formSubmitHandler = (): * => {
    if (
      this.state.eyes &&
      this.state.eyes.length !== 0 &&
      this.state.selected !== null
    ) {
      this.props.formSubmitHandler(this.state.eyes[this.state.selected]);
    } else {
      this.props.setImageError(
        "Can't detect any face in this photo, please take another one."
      );
    }
  };

  render(): * {
    return (
      <div>
        {this.state.eyes && (
          <ImagusFacePicker
            imgUrl={this.props.img}
            faces={this.state.eyes}
            selection={this.state.selected}
            facesDidUpdate={this.updateFaces}
            disableActions
          />
        )}
        {/* <LivenessCheck liveness={this.props.liveness} /> */}
        <UploadFormButton
          formSubmitHandler={this.formSubmitHandler}
          cancelUpload={this.props.cancelUpload}
        />
      </div>
    );
  }
}

export default EnrolForm;



// WEBPACK FOOTER //
// ./src/conference/component/EnrolForm.js